import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  deleteAssignmentById,
  resetdeleteAssignment,
} from "../../state/actions/deleteAssignmentAction";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../features/auth/AuthContext";
import { alert_image } from "../../assets/images/images";
import {
  syncAssignmentsSchoology,
  resetSyncAssignment,
} from "../../state/actions/syncAssignmentsSchoologyAction";
import MenuItem from "@mui/material/MenuItem";
import StyledMenu from "../../components/StyleMenu";
import { Tooltip } from "@mui/material";
import "./AssignmentTab.css"

// ── Shared tooltip style — applied to every <Tooltip> in this file ───────────
// MUI renders the popup via a Popper, so `sx` must go inside
// componentsProps.tooltip to actually reach the visible bubble.
const TOOLTIP_STYLE = {
  tooltip: {
    sx: {
      fontSize: "0.81rem",                      // MUI default is ~0.625rem
      lineHeight: 1.6,
      padding: "8px 14px",
      maxWidth: 320,
      backgroundColor: "rgba(33, 33, 33, 0.92)",
      borderRadius: "6px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
    },
  },
};

const LessonAndAssingmentTab = ({
  accessControl = false,
  UserRoleCourseRights = true,
  type,
  schoology,
  MainTitle,
  title,
  Coursename,
  start_date,
  end_date,
  Progress_btn,
  Lessonname,
  subjecttitle,
  titleHeader,
  isAssignmentTab,
  course,
  lesson,
  lesson_id,
  courseId,
  assignment,
  teacher_id,
  Editbutton,
  refreshAssignments,
  assignmentSyncedId,
  setAssignmentSyncedId,
  editbtn,
  student_enrollment_count,
  submission_count,
  index,
  roleFromState,
  myRole,
}) => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const dispatch = useDispatch();
  const deleteAssignmentState = useSelector((state) => state.deleteAssignment);
  const [deleteAssignment, setdeleteAssignment] = useState(false);

  const getassignmentcount = (counter) => {
    let value = counter + 1;
    return " " + value;
  };

  const globalState = useSelector((state) => state.globalState);
  const UserRole = globalState?.role;
  const ai_feedback_json = assignment?.ai_feedback_json;
  const isFeedbackGenerating = !ai_feedback_json;

  const departmentRole =
    globalState?.teacher_details?.data?.teacher_department_roles;
  const accessLessonEdit =
    UserRole === "Admin" ||
    departmentRole === "teacher" ||
    departmentRole === "advisor" ||
    departmentRole === "learning specialist" ||
    departmentRole === "hod";

  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuIconClick = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  let UserRoleRights;
  if (UserRole === "Teacher") {
    UserRoleRights = true;
  } else {
    UserRoleRights = false;
  }
  if (UserRoleCourseRights === false) {
    UserRoleRights = false;
  }

  const deleteAssignmentReq = (id) => {
    dispatch(deleteAssignmentById(id, token)).then(() => {
      setdeleteAssignment(false);
      refreshAssignments();
    });
  };

  const handleEditBtn = (course, teacher_id, lesson, assignment) => {
    if (assignment.is_skip) {
      const key = `previewLessonData`;
      const data = {
        course,
        teacher_id,
        lesson,
        // assignment,
        openFirstAssignment: true,
        targetAssignmentIndex: 0,
      };
      sessionStorage.setItem(key, JSON.stringify(data));
      const url = `/NewLessons?course_id=${course.course_id || courseId}&teacher_id=${teacher_id}&lesson_id=${lesson.lesson_id || lesson_id}&openFirstAssignment=true&targetAssignmentIndex=0&skip_lesson=true`;
      window.open(url, "_blank");
    } else {
      const key = `previewLessonData`;
      const data = { course, teacher_id, lesson, assignment };
      sessionStorage.setItem(key, JSON.stringify(data));
      const url = `/NewLessons?lesson_id=${lesson.lesson_id || lesson_id}&course_id=${course.course_id || courseId}&teacher_id=${teacher_id}`;
      window.open(url, "_blank");
    }
  };

  const handleSync = (e, id) => {
    const isChecked = e.target.checked;
    const res = { assignment_ids: [id], toggle: isChecked };
    if (isChecked) {
      setAssignmentSyncedId([...assignmentSyncedId, id]);
    } else {
      setAssignmentSyncedId(assignmentSyncedId.filter((aid) => aid !== id));
    }
    dispatch(syncAssignmentsSchoology(res, token));
  };

  return (
    <>
      <div className="Student-Active-Lesson-container" id="Lesson_Container">
        <div className="Student-Active-main-wrapper">
          <div
            className="Student-Active-Lesson-folder active_assignment_folder !grid !grid-cols-3 !gap-4"
            style={{ position: "relative" }}
          >
            <div className="Student-Active-Lesson-container flex flex-row mb-0 !w-full">
              <div className="Student-Active-Lesson-title-folder items-start">
                <h2 className="text-left assg-head" style={{ width: "200px" }}>
                  {type + " " + getassignmentcount(titleHeader) + " : "}

                  {type === "Lesson" ? (
                    <Tooltip
                      title={title}
                      placement="top"
                      componentsProps={TOOLTIP_STYLE}
                    >
                      <span className="text-left">{title}</span>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={title}
                      placement="top"
                      componentsProps={TOOLTIP_STYLE}
                    >
                      <span className="text-left">{title}</span>
                    </Tooltip>
                  )}
                </h2>

                {isAssignmentTab && (
                  <span className="Student-Active-Assignment-des text-left assg-head flex">
                    <span className="mr-2">{subjecttitle}{" "}</span>
                    <Tooltip
                      title={Lessonname}
                      placement="top"
                      componentsProps={TOOLTIP_STYLE}
                    >
                      <span className="block w-[210px] overflow-hidden text-ellipsis whitespace-nowrap assg-head">
                        {Lessonname}
                      </span>
                    </Tooltip>
                  </span>
                )}

                <span className="Student-Active-Assignment-des assg-head text-left">
                  <span className="mr-2">Course :</span>
                  <Tooltip
                    title={Coursename}
                    placement="top"
                    componentsProps={TOOLTIP_STYLE}
                  >
                    <span>{Coursename}</span>
                  </Tooltip>
                </span>
              </div>

              {((accessLessonEdit && myRole !== "viewer") ||
                (!accessControl &&
                  !UserRoleRights &&
                  Editbutton &&
                  myRole !== "viewer")) && !course.is_archived && (
                <div className="edit-course-dropdown-menu-container mobile-three-dot-menu">
                  <div
                    className="edit-course-or-delete-course"
                    style={{ cursor: "pointer" }}
                    onClick={handleMenuIconClick}
                  >
                    <i className="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <StyledMenu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    {/* Edit */}
                    {accessLessonEdit && myRole !== "viewer" && (
                      <MenuItem
                        onClick={() => {
                          handleMenuClose();
                          if (type === "Lesson") {
                            const key = `previewLessonData`;
                            sessionStorage.setItem(
                              key,
                              JSON.stringify({ course, teacher_id, lesson })
                            );
                            window.open(
                              `/NewLessons?lesson_id=${lesson.lesson_id || lesson_id}&course_id=${course.course_id || courseId}&teacher_id=${teacher_id}`,
                              "_blank"
                            );
                          } else if (Editbutton && editbtn === "edit-assignment") {
                            handleEditBtn(course, teacher_id, lesson, assignment);
                          }
                        }}
                        disableRipple
                        sx={{
                          backgroundColor: "transparent !important",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        <button type="button" className="course-edit-or-delete-folder">
                          <a href="#"><i className="fa-solid fa-pencil"></i></a>
                          <p>Edit</p>
                        </button>
                      </MenuItem>
                    )}

                    {/* Delete */}
                    {!accessControl &&
                      !UserRoleRights &&
                      Editbutton &&
                      myRole !== "viewer" && (
                        <MenuItem
                          onClick={() => {
                            handleMenuClose();
                            setdeleteAssignment(true);
                          }}
                          disableRipple
                          sx={{
                            backgroundColor: "transparent !important",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                        >
                          <button type="button" className="course-edit-or-delete-folder">
                            <a href="#"><i className="fa-solid fa-trash"></i></a>
                            <p>Delete</p>
                          </button>
                        </MenuItem>
                      )}
                  </StyledMenu>
                </div>
              )}
            </div>

            <div className="view-course-details-container flex-nowrap justify-center lg:gap-[32px]">
              <div className="view-Students-course-details-folder">
                <span>{type} Start Date:</span>
                <div className="view-Students-course-details-counts">
                  <p>{start_date}</p>
                </div>
              </div>
              <div className="view-Students-course-details-folder">
                <span>{type} End Date:</span>
                <div className="view-Students-course-details-counts">
                  <p>{end_date}</p>
                </div>
              </div>
            </div>

            <div className="button_tab_wrapper justify-center md:justify-end">
              {editbtn === "edit-assignment" && (
                <Tooltip
                  title={isFeedbackGenerating ? "Assignment is being generated. Please wait!" : ""}
                  placement="bottom"
                  componentsProps={TOOLTIP_STYLE}
                >
                  <span
                    style={{
                      display: "inline-block",
                      cursor: isFeedbackGenerating ? "not-allowed" : undefined,
                    }}
                  >
                    <button
                      type="button"
                      disabled={isFeedbackGenerating}
                      className="Student-Active-start-Lesson assingment_view_btn w-max !ml-0"
                      style={
                        isFeedbackGenerating
                          ? { opacity: 0.5, pointerEvents: "none" }
                          : undefined
                      }
                      onClick={() => {
                        const assignment_id = assignment?.assignment_id;
                        navigate(
                          `/course/${course.course_id || courseId}/lesson/${lesson.lesson_id || lesson_id}/assignment/${assignment_id}/preview`,
                          {
                            state: { course, teacher_id, lesson, assignment, isTeacher: true },
                          }
                        );
                      }}
                    >
                      <span>View Assignment</span>
                    </button>
                  </span>
                </Tooltip>
              )}

              {type !== "Lesson" && (
                <>
                  <button
                    className="Student-Active-start-Lesson assingment_progress_btn !p-2 w-max !ml-0"
                    onClick={() => {
                      const assignment_id = assignment?.assignment_id;
                      navigate(
                        `/course/${course.course_id || courseId}/lesson/${lesson.lesson_id || lesson_id}/progress`,
                        {
                          state: {
                            accessControl,
                            UserRoleRights,
                            course,
                            teacher_id,
                            lesson,
                            lesson_id,
                            courseId,
                            assignment_id,
                            tabValue: "assignments",
                            assignment_name: assignment?.name,
                            assignment_start_date: assignment?.start_date,
                            assignment_end_date: assignment?.end_date,
                            course_type: assignment?.course_type,
                            roleFromState,
                            myRole,
                            submission_count,
                            student_enrollment_count
                          },
                        }
                      );
                    }}
                  >
                    View Submissions
                  </button>
                  {editbtn === "edit-assignment" && (
                    <div className="submisson-enrollment-count">
                      <p className={`flex justify-end ${!accessControl && !UserRoleRights ? "w-full ml-40" : ""}`}>
                        {`${submission_count}/${student_enrollment_count} Submissions`}
                      </p>
                    </div>
                  )}
                </>
              )}

              <div className="desktop-lesson-actions">
                {accessLessonEdit && !course.is_archived && myRole !== "viewer" && (
                  type === "Lesson" ? (
                    <button
                      type="button"
                      className="button_tab_edit_btn !p-0"
                      onClick={() => {
                        const key = `previewLessonData`;
                        sessionStorage.setItem(key, JSON.stringify({ course, teacher_id, lesson }));
                        window.open(
                          `/NewLessons?lesson_id=${lesson.lesson_id || lesson_id}&course_id=${course.course_id || courseId}&teacher_id=${teacher_id}`,
                          "_blank"
                        );
                      }}
                    >
                      <span><i className="fa-solid fa-pencil"></i></span>
                      <p>Edit</p>
                    </button>
                  ) : Editbutton && editbtn === "edit-assignment" ? (
                    <button
                      type="button"
                      className="button_tab_edit_btn !p-0"
                      onClick={() => handleEditBtn(course, teacher_id, lesson, assignment)}
                    >
                      <span><i className="fa-solid fa-pencil"></i></span>
                      <p>Edit</p>
                    </button>
                  ) : null
                )}

                {!accessControl && !course.is_archived && !UserRoleRights && Editbutton && myRole === "owner" && (
                  <Tooltip
                    title="Delete Assignment"
                    placement="bottom"
                    componentsProps={TOOLTIP_STYLE}
                  >
                    <i
                      className="fa-solid fa-trash"
                      onClick={() => setdeleteAssignment(true)}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteAssignment && (
        <form action="" className="delete-course-form">
          <div className="delete-course-form-container" data-aos="zoom-in">
            <div className="delete-course-alert-image">
              <img src={alert_image} alt="" />
            </div>
            <h2>Are you sure you want to delete this assignment?</h2>
            <div className="delete-course-form-btn-folder">
              <button
                type="button"
                onClick={() => setdeleteAssignment(false)}
                className="not-delete-btn"
              >
                No
              </button>
              {deleteAssignmentState?.isLoading ? (
                <div className="loading-spinner" />
              ) : (
                <button
                  type="button"
                  onClick={() => deleteAssignmentReq(assignment?.assignment_id)}
                  disabled={deleteAssignmentState?.isLoading}
                  className="delete-btn"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default LessonAndAssingmentTab;